// SPDX-License-Identifier: AGPL-3.0-or-later

// The inline watchdog in index.html paints a splash before any module script
// arrives and reloads the shell when a hashed asset 404s. Once React has
// mounted (or the bootstrap error screen is showing) it must be told so it
// can reset its recovery counter and take the splash down. The splash removes
// itself: in the desktop and mobile apps it first lets the logo land and the
// wordmark write, over the already mounted app; `instant` skips that.
interface KonvoBootBridge {
	ready(instant?: boolean): void;
	recover(): void;
}

declare global {
	interface Window {
		__KONVO_BOOT__?: KonvoBootBridge;
	}
}

export function markBootComplete({instant = false}: {instant?: boolean} = {}): void {
	const bridge = window.__KONVO_BOOT__;
	if (bridge) {
		try {
			bridge.ready(instant);
			return;
		} catch {}
	}
	const splash = document.getElementById('konvo-boot');
	splash?.parentNode?.removeChild(splash);
}
